import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { api } from "@/lib/api";

function formatDate(value: string | null): string {
  if (!value) return "never";
  return new Date(value).toLocaleString();
}

export function Services() {
  const { data: subscriptions, isLoading } = useQuery({
    queryKey: ["subscriptions"],
    queryFn: api.listSubscriptions,
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-lg font-semibold">Services</h1>
        <p className="max-w-2xl text-sm text-muted-foreground">
          Paid add-on products a machine can be subscribed to.
        </p>
      </div>

      {isLoading && <p className="text-sm text-muted-foreground">Loading…</p>}
      {subscriptions?.length === 0 && (
        <p className="text-sm text-muted-foreground">No services configured.</p>
      )}

      <div className="space-y-4">
        {subscriptions?.map((subscription) => (
          <Card key={subscription.id}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0">
              <div className="flex items-center gap-2">
                <CardTitle className="text-base font-medium">
                  <Link to={`/services/${subscription.slug}`} className="hover:underline">
                    {subscription.name}
                  </Link>
                </CardTitle>
                <Badge variant="secondary">{subscription.slug}</Badge>
              </div>
            </CardHeader>
            <CardContent>
              <div className="flex gap-8 text-sm">
                <div>
                  <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
                    Subscribed boxes
                  </p>
                  <p className="text-lg font-semibold">{subscription.subscriber_count}</p>
                </div>
                <div>
                  <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
                    Last updated
                  </p>
                  <p className="text-muted-foreground">{formatDate(subscription.last_updated)}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
